import React from "react";
import { Handle, Position } from "@xyflow/react";
import { FaBolt } from "react-icons/fa";

const matchLabels = {
  contains: "Contains",
  exact: "Exact match",
  startsWith: "Starts with",
  regex: "Regex",
  any: "Any message",
};

export default function TriggerNode({ data, selected }) {
  return (
    <div
      className={`rounded-xl border-2 bg-surface-card shadow-sm min-w-[200px] transition-shadow ${
        selected ? "border-brand shadow-md" : "border-surface-border"
      }`}
    >
      {/* Header */}
      <div className="flex items-center gap-2 px-3 py-2 rounded-t-[10px]"
        style={{ background: "linear-gradient(135deg, #00b894, #009970)" }}>
        <FaBolt size={11} className="text-white" />
        <span className="text-xs font-semibold text-white">Message Received</span>
      </div>

      {/* Body */}
      <div className="px-3 py-2.5">
        {(() => {
          if (data.matchType === "any") {
            return (
              <>
                <p className="text-2xs text-ink-muted mb-0.5">Any message</p>
                <p className="text-xs font-medium text-ink-primary">Every message &amp; attachment</p>
              </>
            );
          }
          const list = Array.isArray(data.keywords)
            ? data.keywords
            : (typeof data.keyword === "string" && data.keyword.trim()
                ? data.keyword.split(",").map((k) => k.trim().replace(/^["']|["']$/g, "")).filter(Boolean)
                : []);
          if (list.length === 0) {
            return <p className="text-xs text-ink-muted italic">Click to configure</p>;
          }
          return (
            <>
              <p className="text-2xs text-ink-muted mb-0.5">
                {matchLabels[data.matchType] || "Contains"}
              </p>
              <p className="text-xs font-medium text-ink-primary truncate">
                {list.slice(0, 3).map((k) => `"${k}"`).join(", ")}
                {list.length > 3 ? ` +${list.length - 3} more` : ""}
              </p>
            </>
          );
        })()}
      </div>

      {/* Output handle */}
      <Handle
        type="source"
        position={Position.Bottom}
        className="!w-3 !h-3 !bg-brand !border-2 !border-white"
      />
    </div>
  );
}
